module.exports = __webpack_public_path__ + "ba8f40c860e36923971eaf6301d178f6.jpg";